import Grid from "components/Grid";
import Text from "components/Text";
import { routeConstants } from "constants/routeConstants";
import { FC } from "react";
import { RiUserLine } from "react-icons/ri";
import { AdressProps } from "../../ContactCard";
import CardTitle from "../CardTitle";
import {
    Bullet,
    BulletColumn,
    CardWrapper,
    Label,
} from "./PersonalInfo.styled";

export const PersonalInfo: FC<{ addressInfo: AdressProps }> = ({
    addressInfo: { address, city, country, state, zip },
}) => {
    return (
        <CardWrapper>
            <CardTitle
                icon={<RiUserLine />}
                title="Company Info"
                editRoute={
                    routeConstants.profile.editProfile.agency.root +
                    routeConstants.profile.editProfile.agency.companyDetails
                }
            />
            {address || city || country || state || zip ? (
                <Grid
                    row={true}
                    expanded
                    justify="flex-start"
                    columnGap={1}
                    rowGap={1}
                    marginTop={1}
                >
                    {address && (
                        <BulletColumn>
                            <Label variant="body2">Address</Label>
                            <Bullet>
                                <Text variant="body2">{address}</Text>
                            </Bullet>
                        </BulletColumn>
                    )}
                    {city && (
                        <BulletColumn>
                            <Label variant="body2">City</Label>
                            <Bullet>
                                <Text variant="body2">{city}</Text>
                            </Bullet>
                        </BulletColumn>
                    )}
                    {state && (
                        <BulletColumn>
                            <Label variant="body2">State</Label>
                            <Bullet>
                                <Text variant="body2">{state}</Text>
                            </Bullet>
                        </BulletColumn>
                    )}
                    {country && (
                        <BulletColumn>
                            <Label variant="body2">Country</Label>
                            <Bullet>
                                <Text variant="body2">{country}</Text>
                            </Bullet>
                        </BulletColumn>
                    )}
                </Grid>
            ) : (
                <Grid
                    row={true}
                    expanded
                    justify="flex-start"
                    columnGap={1}
                    marginTop={1}
                >
                    <Text variant="body1">No data found.</Text>
                </Grid>
            )}
        </CardWrapper>
    );
};
